import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { get } from 'lodash';
import { bool, func, number, object, shape, string } from 'prop-types';
import { injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import omit from 'lodash/omit';
import moment from 'moment-timezone';
import { locationRadiusBounds } from '../../util/googleMaps';
import { FilterButton, SelectMultipleFilter } from '../../components';
import routeConfiguration from '../../routeConfiguration';
import { parseDateFromISO8601 } from '../../util/dates';
import { createResourceLocatorString } from '../../util/routes';
import { propTypes } from '../../util/types';
import css from './LongTermSearchFilters.css';
import arrowDown from '../../assets/arrow-down-black.svg';
import { isMobile } from 'react-device-detect';
import LongTermSortBy from '../LongTermSortBy/LongTermSortBy';

// Distance for home delivery in meters
const LIMIT_DISTANCE = 5200;

// Dropdown container can have a positional offset (in pixels)
const FILTER_DROPDOWN_OFFSET = -14;
const RADIX = 10;

// resolve initial value for a single value filter
const initialValue = (queryParams, paramName) => {
  return queryParams[paramName];
};

// resolve initial values for a multi value filter
const initialValues = (queryParams, paramName) => {
  return !!queryParams[paramName] ? queryParams[paramName].split(',') : [];
};

const initialPriceRangeValue = (queryParams, paramName) => {
  const price = queryParams[paramName];
  const valuesFromParams = !!price ? price.split(',').map(v => Number.parseInt(v, RADIX)) : [];

  return !!price && valuesFromParams.length === 2
    ? {
        minPrice: valuesFromParams[0],
        maxPrice: valuesFromParams[1],
        price,
      }
    : null;
};

const initialDateRangeValue = (queryParams, paramName) => {
  const dates = queryParams[paramName];
  const hours = queryParams['hours'];
  const rawHoursValues = hours ? hours.split(',') : [];
  const rawValuesFromParams = !!dates ? dates.split(',') : [];
  const valuesFromParams = rawValuesFromParams.map(v => parseDateFromISO8601(v));
  const initialValues =
    !!dates && valuesFromParams.length === 2
      ? {
          dates: { startDate: valuesFromParams[0], endDate: valuesFromParams[1] },
        }
      : { dates: null };
  if (hours && rawHoursValues.length === 2) {
    initialValues.times = {
      pickupTime: moment(rawHoursValues[0], 'HH:mm').format('hh:mm a'),
      dropOffTime: moment(rawHoursValues[1], 'HH:mm').format('hh:mm a'),
    };
  } else {
    initialValues.times = null;
  }
  return initialValues;
};
const LongTermSearchFiltersComponent = props => {
  const {
    rootClassName,
    className,
    urlQueryParams,
    listingsAreLoaded,
    resultsCount,
    categoryFilter,
    amenitiesFilter,
    dateRangeFilter,
    keywordFilter,
    history,
    intl,
    sort,
    isPHVFilter,
    isAgeOfCar,
    currentUser,
    canDriveToMalaysiaFilter,
    openFilterModal,
    brandNamesFilter,
    typeOfFuelFilter,
    isMobileLayout,
  } = props;

  const hasNoResult = listingsAreLoaded && resultsCount === 0;
  const classes = classNames(rootClassName || css.root, { [css.longInfo]: hasNoResult }, className);
  const [openSlider, setOpenSlider] = useState(false);
  const [value1, setValue1] = useState(0);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(500);

  useEffect(() => {
    // dasd
  });

  const categoryLabel = intl.formatMessage({
    id: 'SearchFilters.categoryLabel',
  });
  const initialCategory = categoryFilter
    ? initialValues(urlQueryParams, categoryFilter.paramName)
    : null;
  const initialBrandNames = brandNamesFilter
    ? initialValues(urlQueryParams, brandNamesFilter.paramName)
    : null;
  const initialTypeOfFuelNames = typeOfFuelFilter
    ? initialValues(urlQueryParams, typeOfFuelFilter.paramName)
    : null;

  const initialPriceRange = initialPriceRangeValue(urlQueryParams, 'price');



  const initialKeyword = keywordFilter
    ? initialValue(urlQueryParams, keywordFilter.paramName)
    : null;

  const isKeywordFilterActive = !!initialKeyword;

  const handleSelectOptions = (urlParam, options) => {
    const queryParams =
      options && options.length > 0
        ? { ...urlQueryParams, [urlParam]: options.join(',') }
        : omit(urlQueryParams, urlParam);

    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };

  const handleSelectOption = (urlParam, option) => {
    const queryParams = option
      ? { ...urlQueryParams, [urlParam]: option }
      : omit(urlQueryParams, urlParam);

    if (urlParam === 'pub_delivery') {
      const userLocation = get(
        currentUser,
        'attributes.profile.protectedData.location.selectedPlace.origin'
      );
      const newBounds = userLocation && locationRadiusBounds(userLocation, LIMIT_DISTANCE);
      newBounds && (queryParams.bounds = newBounds);
    }

    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };

  const handlePrice = urlParam => {
    const range = `${minValue},${maxValue}`;
    const queryParams = range
      ? { ...urlQueryParams, [urlParam]: range }
      : omit(urlQueryParams, urlParam);
    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };
  const openRangeSilder = () => {
    setOpenSlider(!openSlider);
  };

  const formatDollar = value1 => '$' + value1;

  const handleChange = value1 => {
    setValue1(value1);
  };
  const handleInput = e => {
    setMinValue(e.minValue);
    setMaxValue(e.maxValue);
  };

  const categoryFilterElement = categoryFilter ? (
    <SelectMultipleFilter
      id={'SearchFilters.categoryFilter'}
      name="categories"
      urlParam={categoryFilter.paramName}
      label={categoryLabel}
      onSubmit={handleSelectOptions}
      showAsPopup
      options={categoryFilter.options}
      initialValues={initialCategory}
      contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
      canApply={true}
    />
  ) : null;

  const brandNamesFilterElement = brandNamesFilter ? (
    <SelectMultipleFilter
      id={'SearchFilters.brandNamesFilter2'}
      name="brandNames"
      urlParam={brandNamesFilter.paramName}
      label="Brand"
      onSubmit={handleSelectOptions}
      showAsPopup
      liveEdit
      options={brandNamesFilter.options}
      initialValues={initialBrandNames}
      clearButtonClass={css.clearbutton}
      plainClassName={css.plainClassName}
      threeColumns={true}
      className={css.fullHeight}
      contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
      intl={intl}
      // twoColumns={true}
    />
  ) : null;

  const typeOfFuelFilterElement = typeOfFuelFilter ? (
    <SelectMultipleFilter
      id={'SearchFilters.typeOfFuelFilter'}
      name="brandNames"
      urlParam={typeOfFuelFilter.paramName}
      label="Fuel type"
      onSubmit={handleSelectOptions}
      showAsPopup
      liveEdit
      options={typeOfFuelFilter.options}
      initialValues={initialTypeOfFuelNames}
      clearButtonClass={css.clearbutton}
      threeColumns={true}
      className={css.fullHeight}
      contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
      intl={intl}
      twoColumns={true}
    />
  ) : null;

  const ageOfCarFilterElement = isAgeOfCar ? (
    <FilterButton
      urlParam={isAgeOfCar.paramName}
      label="Younger than 5 years"
      onSubmit={handleSelectOption}
      value={initialValue(urlQueryParams, isAgeOfCar.paramName)}
      hintText={null}
    />
  ) : null;

  const phvFilterFilterElement = isPHVFilter ? (
    <FilterButton
      urlParam={isPHVFilter.paramName}
      label="Allowed PHV"
      onSubmit={handleSelectOption}
      value={initialValue(urlQueryParams, isPHVFilter.paramName)}
      hintText={null}
    />
  ) : null;

  const driveToMalaysiaFilterElement = canDriveToMalaysiaFilter ? (
    <FilterButton
      urlParam={canDriveToMalaysiaFilter.paramName}
      label={intl.formatMessage({ id: 'SearchFilters.canDriveToMalaysiaFilter' })}
      onSubmit={handleSelectOptions}
      value={initialValue(urlQueryParams, canDriveToMalaysiaFilter.paramName)}
      hintText={null}
      showAsPopup
    />
  ) : null;

  const handleSortBy = (urlParam, values) => {
    const queryParams = values
      ? { ...urlQueryParams, [urlParam]: values }
      : omit(urlQueryParams, urlParam);
    if (values === 'relevance') {
      queryParams.sort = 'relevance';
    }
    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };

  const sortConfig = {
    // Enable/disable the sorting control in the SearchPage
    active: true,

    // Internal key for the relevance option, see notes below.
    relevanceKey: 'ageOfCar',

    options: [
      // The relevance is only used for keyword search, but the
      // parameter isn't sent to the Marketplace API. The key is purely
      // for handling the internal state of the sorting dropdown.
      { key: 'ageOfCar', label: 'Age of car' },
      { key: '-pub_flexPlusPrice', label: 'Lowest price' },
      { key: 'pub_flexPlusPrice', label: 'Highest price' },
    ],
  };

  const sortBy = sortConfig.active ? (
    <LongTermSortBy
      sort={sort}
      showAsPopup
      sortConfig={sortConfig}
      isKeywordFilterActive={isKeywordFilterActive}
      onSelect={handleSortBy}
      contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
    />
  ) : null;

  const onSubmit = (urlParam, option) => {
    // e.preventDefault();

    // query parameters after selecting the option
    // if no option is passed, clear the selection for the filter
    const queryParams = option
      ? { ...urlQueryParams, [urlParam]: option }
      : omit(urlQueryParams, urlParam);

    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };
  const _handleFilterChange = (urlParam, option) => {
    // e.preventDefault();

    // query parameters after selecting the option
    // if no option is passed, clear the selection for the filter
    const queryParams = option
      ? { ...urlQueryParams, [urlParam]: option.key }
      : omit(urlQueryParams, urlParam);

    history.push(
      createResourceLocatorString('LongTermRentalSearch', routeConfiguration(), {}, queryParams)
    );
  };

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div className={classNames(css.filtersAndSortWrap, css.row)}>
          <div className={classNames(css.filters, css.column80)}>
            <div className={css.filterWrapper}>
              <div className={css.filterSlection}>
              {isMobile ?
                <button
                  className={css.filterButtons}
                  onClick={() => {
                    openRangeSilder();
                    openFilterModal(true);
                  }}
                >
                  {isMobile ? 'Filter' : 'Price'}
                  <img src={arrowDown} alt="arrow" />
                </button>: ''}
                {/* {!isMobile && (
                  <>
                    {openSlider && (
                      <div
                        className={classNames(css.longTerm_Search_Filters, css.rangeSliderInput)}
                      >
                        <div className={css.price_filter_title}>
                          <h3 className={css.filter_title}>Price/month</h3>
                          <span className={css.filter_range}>$0 - $3000</span>
                        </div>
                        <div className={css.sliderfill}>
                          <MultiRangeSlider
                            baseClassName={css.multiSliderCss}
                            min={0}
                            max={3000}
                            step={500}
                            minValue={(initialPriceRange && initialPriceRange.minPrice) || minValue}
                            maxValue={(initialPriceRange && initialPriceRange.maxPrice) || maxValue}
                            minCaption={`$${minValue}`}
                            maxCaption={`$${maxValue}`}
                            onInput={e => {
                              handleInput(e);
                            }}
                          />
                        </div>
                        <div className={css.priceFilterSubmit}>
                          <span className={css.filter_range} onClick={() => handlePrice('price')}>
                            Clear
                          </span>
                          <span className={css.filter_range} onClick={() => handlePrice('price')}>
                            Apply
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )} */}
              </div>
              {!isMobile && (
                <>
                  {categoryFilterElement}
                  {typeOfFuelFilterElement}
                  {phvFilterFilterElement}
                  {/* {ageOfCarFilterElement} */}
                  {brandNamesFilterElement}
                </>
              )}
            </div>
          </div>
          <div className={classNames(css.sorts, css.column20)}>{sortBy}</div>
        </div>
      </div>
    </div>
  );
};

LongTermSearchFiltersComponent.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchingInProgress: false,
  categoryFilter: null,
  amenitiesFilter: null,
  priceFilter: null,
  dateRangeFilter: null,
  isSearchFiltersPanelOpen: false,
  toggleSearchFiltersPanel: null,
  searchFiltersPanelSelectedCount: 0,
};

LongTermSearchFiltersComponent.propTypes = {
  rootClassName: string,
  className: string,
  urlQueryParams: object.isRequired,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchingInProgress: bool,
  onManageDisableScrolling: func.isRequired,
  categoriesFilter: propTypes.filterConfig,
  amenitiesFilter: propTypes.filterConfig,
  priceFilter: propTypes.filterConfig,
  dateRangeFilter: propTypes.filterConfig,
  isSearchFiltersPanelOpen: bool,
  toggleSearchFiltersPanel: func,
  searchFiltersPanelSelectedCount: number,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const LongTermSearchFilters = compose(withRouter, injectIntl)(LongTermSearchFiltersComponent);

export default LongTermSearchFilters;
